<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="flex items-center justify-between mb-3"></div>
    <EldForm
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vx-card
      title="ELDs"
      collapse-action
      refresh-content-action
      @refresh="closeCardAnimationDemo"
    >
      <vs-table
        ref="table"
        v-if="elds"
        pagination
        :max-items="itemsPerPage"
        search
        :data="elds"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
            <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add ELD</span>
            </div>
          </div>
        </div>
        <template slot="thead">
          <vs-th sort-key="firstname">Serial No</vs-th>
          <vs-th sort-key="notes">Notes</vs-th>
          <vs-th></vs-th>
          <vs-th>Edit/Deactivate</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody class="nmadir">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.serial_number }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.notes_eld }}
                </p>
              </vs-td>
              <vs-td> </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  v-if="tr.status === true"
                  icon="XIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="ChangeStatus(tr, false)"
                />
                <feather-icon
                  v-if="tr.status === false"
                  icon="CheckIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="ChangeStatus(tr, true)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
import EldForm from "./components/EldForm.vue";
export default {
  components: {
    EldForm,
  },
  data() {
    return {
      itemsPerPage: 4,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    elds() {
      return this.$store.state.eld.elds;
    },
  },
  methods: {
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.$store.dispatch("eld/fetchDataListItems");
      }, 3000);
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    ChangeStatus(tr, val) {
      this.$store
        .dispatch(`eld/updateItem`, {
          id: tr.id,
          serial_number: tr.serial_number,
          status: val,
        })
        .then(() => {
          this.$store.dispatch("eld/fetchDataListItems");
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.$store.dispatch("eld/fetchDataListItems");
      this.addNewDataSidebar = val;
      this.$store.dispatch("eld/fetchDataListItems");
    },
  },
  created() {
    this.$store.dispatch("eld/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
